import { IsNotEmpty, IsString, IsUUID } from 'class-validator';

export class ChatUpdateNameRequest {
    @IsUUID()
    public readonly chatUuid: string;

    @IsString()
    @IsNotEmpty()
    public readonly chatName: string;

    constructor(data?: Partial<ChatUpdateNameRequest>) {
        this.chatUuid = data?.chatUuid;
        this.chatName = typeof data?.chatName === 'string' ? data.chatName.trim() : data?.chatName;
    }
}
